import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UrlModule, I18nModule, ConfigModule, AuthGuard } from '@spartacus/core';
import { IconModule, PageComponentModule } from '@spartacus/storefront';
import { KbOrderDetailsPageComponent } from './kb-order-details-page/kb-order-details-page.component';
import { KbMyOrdersSearchComponent } from './kb-my-orders-search/kb-my-orders-search.component';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbMyAccountLeftSideNavModule } from "../my-account-left-sidenav/my-account-left-sidenav.module";
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KbPaginationModule } from '../../kb-pagination/kb-pagination/kb-pagination.module';



@NgModule({
    declarations: [
        KbOrderDetailsPageComponent,
        KbMyOrdersSearchComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        UrlModule,
        IconModule,
        I18nModule,
        KbPaginationModule,
        PageComponentModule,
        BsDatepickerModule,
        FormsModule,
        ReactiveFormsModule,
        ConfigModule.withConfig({
            cmsComponents: {
                MyTicketFleComponent: {
                    component: KbOrderDetailsPageComponent,
                    guards: [AuthGuard, SecureGuard]
                },
                OrderFlexComponent:{
                    component:KbOrderDetailsPageComponent,
                    guards:[AuthGuard, SecureGuard]
                }
            }
        }),
        KbMyAccountLeftSideNavModule
    ]
})
export class KbMyOrdersModule { }
